//* Libraries imports
import { useState } from "react";
import { Download, Eye } from "lucide-react";

//* Utils imports
import { downloadPdfBase64, CONTRACT_PDF_BASE64 } from "./utils";

//* Components imports
import { SalesContractViewer } from "./SalesContractViewer";

export function SalesContractArea() {
  const [viewerVisible, setViewerVisible] = useState<boolean>(false);

  const handleDownload = () => {
    downloadPdfBase64(CONTRACT_PDF_BASE64, "Contrato-de-venda.pdf");
  };

  return (
    <div className="flex flex-col gap-5 p-5 w-full">
      <div className="flex items-start">
        <h2 className="text-xl font-medium text-clarotexto-201 w-full">
          Contrato de venda
        </h2>
      </div>

      <div className="flex items-center justify-between gap-4">
        <button
          onClick={handleDownload}
          className="flex-1 h-10 px-3 bg-clarobg-202 border border-clarobordas-01 rounded-lg flex items-center justify-center gap-3 hover:bg-gray-100 transition-colors"
        >
          <span className="text-sm text-clarotexto-201 font-normal">
            Baixar
          </span>
          <Download size={16} className="text-clarotexto-201" />
        </button>

        <button
          onClick={() => setViewerVisible(true)}
          className="flex-1 h-10 px-3 bg-clarobg-202 border border-clarobordas-01 rounded-lg flex items-center justify-center gap-3 hover:bg-gray-100 transition-colors"
        >
          <span className="text-sm text-clarotexto-201 font-normal">
            Visualizar
          </span>
          <Eye size={16} className="text-clarotexto-201" />
        </button>
      </div>

      <div className="h-px bg-clarobordas-01 w-full" />

      <SalesContractViewer
        visible={viewerVisible}
        onClose={() => setViewerVisible(false)}
      />
    </div>
  );
}
